import React, { useEffect, useState } from "react";
import Plan from "../../plan";

export default function SecondStep({ onClick, start, details, page }) {
  return <Plan onClick={onClick} start={start} details={details} page={page} />;
}
